export enum FancyTextPanels {
  DEFAULT = '',
  COLOR = 'color',
  SHADOW = 'shadow',
  ANIMATION = 'animation',
}
